import PropTypes from 'prop-types';
import React, {
  useEffect,
  useState,
} from 'react';

import { Map, Iterable } from 'immutable';

import Grid       from '@mui/material/Grid';
import TextField  from '@mui/material/TextField';

import debounce from 'helpers/debounce';

function Text({ name = null, value = null, onChange = null, disabled = false, forced }) {
  const [state, setState] = useState(new Map());

  const localValue = state.get('localValue', (value && value.get('value')) || '');

  function onTextChange(e) {
    const input = e.target.value;
    setState(state.set('localValue', input));

    // Note: Moved out of useEffect to avoid retriggering of "save()" when toggling back via "prev" button
    debounce(() => {
      onChange(name, new Map({ text: input }));
    }, 500, name);
  }

  useEffect(() => {
    if (forced) {
      onChange(name, new Map({ text: localValue || t('eos.landing_page.label.no_answer'), forced: true }));
    }
  }, [forced]);

  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <TextField
          id={name}
          type="text"
          InputLabelProps={{ shrink: true }}
          multiline
          rows={3}
          sx={{ width: '100%' }}
          value={localValue}
          onChange={(e) => onTextChange(e)}
          data-testid="textfield-text"
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
}

Text.propTypes = {
  name:     PropTypes.string,
  value:    PropTypes.objectOf(Iterable),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Text;
